export default __webpack_public_path__ + "static/3-student-3c8c35377c5ac9d9401553c4f3a1dcf9.jpg";